import { ref, computed } from 'vue'

export function useExplorerSort() {
  const sortKey = ref('name')
  const sortDirection = ref<'asc' | 'desc'>('asc')

  const isSort = (value: string) => sortKey.value === value

  const headerIconClasses = computed(() => ({
    ...(sortDirection.value === 'desc' && { 'rotate-180': true }),
  }))

  const handleSort = (key: string) => {
    sortDirection.value =
      sortKey.value === key
        ? sortDirection.value === 'asc'
          ? 'desc'
          : 'asc'
        : 'asc'

    sortKey.value = key

    return [sortKey.value, sortDirection.value] as const
  }

  return {
    sortKey,
    sortDirection,
    isSort,
    headerIconClasses,
    handleSort,
  }
}
